import { h } from 'vue';
import { message } from 'ant-design-vue';
import i18n from '@/i18n';

import Utils from '@/api/Utils';

const t = i18n.global.t;

const getJsonData = text => {
	try {
		return [JSON.parse(text), true];
	} catch (e) {
		return [text, false];
	}
}

const getErrorText = (key, value) => {
	const [data, isJson] = getJsonData(value);
	if (!isJson) {
		return value;
	}
	let lines = [t('uniqueness.messages.' + data['message_id'], data)];
	for (let source of data.sources) {
		let parts = ['uniqueness.fields', source['object_type']];
		if (source.field) {
			parts.push(source.field);
		}
		lines.push(t(parts.join('.'), source));
	}
	return lines.join('\n');
}


const OVERWRITES = {
	'Unable to log in with provided credentials.': 'login.invalidCredentials',
}


const getErrorComponent = (field, value) => {
	const [data, isJson] = getJsonData(value);
	if (!isJson) {
		const header = field ? (field + ': ') : '';
		const newValue = (value in OVERWRITES) ? t('ierrors.' + OVERWRITES[value]) : value;
		return h('div', header + newValue);
	}
	const vars = {
		...data.data,
		field,
	};
	return h('div', t('ierrors.' + data.key, vars));
}

const showErrorMessage = errors => {
	let components = [];
	if (Utils.isObjectWithData(errors)) {
		for (const [key, values] of Object.entries(errors)) {
			for (const value of values) {
				if (key === 'non_field_errors') {
					components.push(getErrorComponent('', value));
				} else {
					components.push(getErrorComponent(key, value));
				}
			}
		}
	}
	message.error(h('span', [
		h('span', { style: { 'font-weight': 'bold' } }, t('common.error')),
		h('div', { style: { 'text-align': 'left' } }, components),
	]));
}

export {
	getErrorText,
	showErrorMessage,
}
